import React, { Component } from "react";
import { Fragment } from "react";
// import LineChartWithoutAxis from "../../../d3Components/lineChartWithoutAxis";
import GroupBarWithoutAxis from "../../../d3Components/groupBarWithoutAxis";
// import RangeSlider from "../../../common/rangeSlider";
import helper from "./helper.js";
import "./ModelCard.style.scss";

class ModelCard extends Component {
  state = {
    groupBarData: [],
    value: "",
  };

  componentDidMount() {
    const { perfHistmetrics, allocations, val } = this.props;
    const groupBarData = helper.getGroupBarFromHistmetrics({
      perfHistmetrics,
    });

    let value =
      allocations &&
      allocations !== null &&
      allocations !== undefined &&
      Object.keys(allocations).length &&
      val
        ? allocations[val] * 1
        : 0;
    this.setState({
      groupBarData,
      value,
    });
  }
  componentWillReceiveProps(nextProps) {
    const { perfHistmetrics, allocations, val } = nextProps;
    const groupBarData = helper.getGroupBarFromHistmetrics({
      perfHistmetrics,
    });

    let value =
      allocations &&
      allocations !== null &&
      allocations !== undefined &&
      Object.keys(allocations).length &&
      val
        ? allocations[val] * 1
        : 0;
    this.setState({
      groupBarData,
      value,
    });
  }

  myAllocationHandler = ({ e, val }) => {
    let { value } = e.target;
    // if (value.substring(0, 1) === "0") {
    //   value = value.replace(/^0+/g, "");
    // }
    this.setState({
      value: value * 1,
    });
    this.props.allocationHandler({ id: val, value, e });
  };
  render() {
    const {
      id,
      val,
      radioButtonHandler,
      defaultChecked,
      width,
      headingTxt,
      footerTxt,
      // backtest_data,
      perfHistmetrics,
      benchmarkName,
      noOpacity,
      radioButtonName,
      active_portfolio_id,
      allocation_and_Slider,
      allocationHandler,
      disableRadioButton,
    } = this.props;

    const { groupBarData, value } = this.state;
    return (
      <div
        className="ModelCard"
        style={{
          opacity: noOpacity
            ? "100%"
            : noOpacity === false && active_portfolio_id !== 0
            ? "50%"
            : "",
        }}
      >
        <div className="ModelCard__heading">{headingTxt}</div>
        <div className="ModelCard__body">
          {
            // Object.keys(backtest_data).length > 0 &&
            perfHistmetrics &&
            perfHistmetrics.length > 0 &&
            groupBarData.length > 0 ? (
              // <LineChartWithoutAxis
              //   id={`line_chart_${id}`}
              //   width={width}
              //   height={150}
              //   // allData={backtest_data[val]}
              //   portfolio={
              //     backtest_data && backtest_data[val]["getPortfolioVami"]
              //       ? backtest_data[val]["getPortfolioVami"]
              //       : []
              //   }
              //   benchmark={
              //     backtest_data && backtest_data[val]["getBenchmarkVami"]
              //       ? backtest_data[val]["getBenchmarkVami"]
              //       : []
              //   }
              // />
              <GroupBarWithoutAxis
                id={`line_chart_${id}`}
                w={width}
                h={90}
                data={groupBarData}
                label={benchmarkName}
              />
            ) : val ? (
              <div className="ModelCard__body__no-data">
                No data to display{" "}
              </div>
            ) : null
          }
          {/* <div className="ModelCard__benchmarkName">
            {benchmarkName ? (
              <div className="ModelCard__benchmarkName_b1">
                Benchmark : {benchmarkName}
              </div>
            ) : null}
          </div> */}
        </div>
        <div
          className={
            val && radioButtonHandler
              ? "ModelCard__footer"
              : "ModelCard__footer_allocation"
          }
        >
          {val && radioButtonHandler && (
            <Fragment>
              <input
                type="radio"
                value={val}
                name={radioButtonName}
                checked={defaultChecked}
                onChange={(e) => radioButtonHandler({ value: e.target.value })}
                style={{
                  pointerEvents:
                    val === "" || disableRadioButton === true ? "none" : "auto",
                }}
              />
              <label>{footerTxt}</label>
            </Fragment>
          )}
          {val && allocation_and_Slider && (
            <div className="ModelCard__footer_allocation_content">
              <div className="ModelCard__footer_allocation_content_ip">
                Allocation :{" "}
                <input
                  type="number"
                  min={0}
                  max={100}
                  value={value}
                  onChange={(e) => this.myAllocationHandler({ e, val })}
                />
                %
              </div>
              <div className="ModelCard__footer_allocation_content_slider">
                <input
                  type="range"
                  value={value}
                  min={0}
                  max={100}
                  step={1}
                  onChange={(e) => {
                    this.setState({
                      value: e.target.value * 1,
                    });
                    allocationHandler({ id: val, value: e.target.value, e });
                  }}
                />
                {/* <RangeSlider
                  id={id + "__range"}
                  value={value}
                  min={0}
                  max={100}
                  step={1}
                /> */}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default ModelCard;



// WEBPACK FOOTER //
// ./src/components/pages/Create_portfolio_by_Advisor/model_card/ModelCard.jsx